import { all, fork } from "redux-saga/effects";
import authSaga from "./saga/auth";
import userSaga from "./saga/user";

export default function* () {
  yield all([fork(authSaga), fork(userSaga)]);
}
